import {EntityContact} from "./EntityContact.jsx";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";

export class ClientContact extends EntityContact {
  static get $name() {
    return "ClientContact";
  }

  static relations = {
    clientRecord: { // this will get client record of this record
      foreignKey: "clientId",
      foreignStore: STORE_KEYS.clientStore,
      relatedCollectionName: "contacts", // this key will be added to the parent to get child records -> clientStore.first.contacts will bring all ClientContact records for that client record
    },
    contactRecord: { // this will get contact (detail) record of this record
      foreignKey: "contactId",
      foreignStore: STORE_KEYS.contactStore,
      relatedCollectionName: "clientContacts", // this key will be added to the parent to get child records -> contactStore.first.clientContacts will bring all ClientContact records for that contact record
    }
  }

  static get fields() {
    return [
      { name: "clientId", dataSource: "client" },
    ];
  }
}

ClientContact.exposeProperties();
